import Color from 'color';
import { ColorTransform, ColorSchema } from '../assets';

function transform(color: string, operation: ColorTransform) {
  switch (operation.type) {
    case 'darken':
      return Color(color)
        .darken(operation.amount)
        .hex();
    case 'lighten':
      return Color(color)
        .lighten(operation.amount)
        .hex();
  }
}

// TODO: consider not all colours will be expressed as hex (might want to normalize)
export function colorMapper(
  schema: ColorSchema[],
  colors: string[]
): Record<string, string> {
  const map: Record<string, string> = {};
  for (const i in schema) {
    const sourceBase = schema[i];
    const destBase = colors[i] || sourceBase.color;

    // map base colour
    map[sourceBase.color] = destBase;

    // map variations
    for (const v of sourceBase.variants || []) {
      map[v.color] = transform(destBase, v.operation);
    }
  }
  return map;
}
